// extracted by mini-css-extract-plugin
export default {"PageMenu-menu":"PageMenu-menu3GtQMx-bfM5Q","PageMenu-toggle-item":"PageMenu-toggle-item2PXVtGdsctPi"};